<script>
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import QrcodeVue from 'qrcode.vue'
import { auth as $store } from '@/store/AuthModule'
import RepairFileService from '@/services/RepairFileService'
import { RepairFile } from '@/models/RepairFile'
import DialogBackButton from '@/components/modal/DialogBackButton.vue'

export default {
  name: 'AddAttachmentQRCodeComponent',
  components: { DialogBackButton, QrcodeVue },
  props: {
    currentRepairFileProps: RepairFile,
    attachmentTypeProps: String,
    attachmentFileProps: String
  },
  data() {
    return {
      loading: false,

      currentRepairFile: null,
      attachmentType: null,
      attachmentFile: null,

      qrCodeToken: null,
      qrCodeValue: null,
      qrCodeSize: 200,

      error: null,

      validateButton: undefined
    }
  },
  async created() {
    this.currentRepairFile = this.currentRepairFileProps
    this.attachmentFile = this.attachmentFileProps
    this.attachmentType = this.attachmentTypeProps

    try {
      this.qrCodeToken = await RepairFileService.getAddAttachmentQRCodeToken(
        this.currentRepairFile.technical_id,
        this.attachmentType,
        $store.state.currentCollaborator.technical_id
      )

      this.qrCodeValue =
        window.location.origin +
        '/public/repair-file/add-attachment?token=' +
        this.qrCodeToken.token
    } catch (error) {
      handleResponseError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async back() {
      this.error = {}
      this.$emit('back-to-parent-page')
    },
    async _confirm() {
      try {
        this.loading = true
        await RepairFileService.confirmAttachmentAddedByQrCode(
          this.currentRepairFile.technical_id,
          this.qrCodeToken.token,
          $store.state.currentCollaborator.technical_id
        )
        displayToast(this.$t('COMMON.MESSAGE.ADD_ATTACHMENT_SUCCESS'), 'success')
        this.$emit('back-to-parent-page')
      } catch (error) {
        handleResponseError(error)
        if (error.response.data) {
          this.error = error.response.data
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-form ref="form" @submit.prevent="_confirm">
    <DialogBackButton :back-method="back" />

    <div>
      <div class="content-title">
        {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.TITLE') }}
      </div>

      <div class="mt-8 mb-4 content detail-content">
        <p class="sub-title">
          {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.MESSAGE_1') }}
        </p>
        <p>
          {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.MESSAGE_2') }}
        </p>
      </div>

      <div v-if="attachmentFile !== null" class="mt-2 mb-4 content detail-content">
        <p class="sub-title">
          {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.MESSAGE_WARNING') }}
        </p>
      </div>

      <div class="mt-3 mb-4 qr-code-content">
        <qrcode-vue :value="qrCodeValue" :size="qrCodeSize" level="L" />
      </div>

      <!--Send button-->
      <div class="d-flex justify-center">
        <v-btn
          :disabled="loading"
          :loading="loading"
          class="boom-button dialog-button"
          variant="outlined"
          type="submit"
        >
          {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.VALIDATION_BUTTON') }}
          <template v-slot:prepend>
            <img alt="send-icon" class="send-white-svg" src="@/assets/icons/file/send.svg" />
          </template>
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<style scoped>
.dialog-button {
  min-width: 200px;
}

.content-title {
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content {
  display: flex;
  justify-content: center;
}

.detail-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.qr-code-content {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.send-white-svg {
  height: 100%;
  width: 100%;
  filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
}
</style>
